query LookupNameSearch (
  $transactionTypeId: Int
  $lookupName: String!
  $documentTypeId: Int
)  {
  lookupNameSearch(transactionTypeId: $transactionTypeId, lookupName: $lookupName, documentTypeId: $documentTypeId) {
    nodes {
      lookupName
      id
      isApprovedVendor 
      lookupCode 
      lookupName
      lookupName2 
      address1
      address2 
      city
      state
      zipCode
      country
      phone
      emailAccount
    }
  }
}
